import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login/Login.vue";
import Apply from "./views/Login/Apply.vue";
import Forget from "./views/Login/Forget.vue";
import Verification from "./views/Login/Verification.vue";
import SmsVerification from "./views/Login/SmsVerification.vue";
import Modify from "./views/Login/Modify.vue";
import Complete from "./views/Login/Complete.vue";
// import Home from "./views/Home.vue";
// import Welcome from "./views/Welcome.vue";
// import User from "./views/User.vue";
// import Order from "./views/Order/Order.vue";
import EnterCertifi from "./views/UaerData/EnterCertifi.vue";
import DataProcessing from "./views/UaerData/DataProcessing.vue";
import DataAcquisition from "./views/UaerData/DataAcquisition.vue";
import Certification from "./views/UaerData/Certification.vue";
import UserTab from "./views/UaerData/UserTab.vue";
import DataCollection from "./views/Order/DataCollection.vue";
import DataProcessingOrder from "./views/Order/DataProcessingOrder.vue";
import AcquisitionProcessing from "./views/Order/AcquisitionProcessing.vue";
import Solution from "./views/Order/Solution.vue";
import OtherServices from "./views/Order/OtherServices.vue";
import OrderContent from "./views/Order/OrderContent.vue";

import Clause from "./views/Login/Clause.vue";

import DataAcquisitionSecond from "./views/UaerData/DataAcquisitionSecond.vue";
import Registered from "./views/Login/Registered.vue";
import Index from "./views/Index.vue";
import SoftwareCenter from "./views/SoftwareCenter.vue";
import TaiRuiCollege from "./views/TaiRuiCollege.vue";
import Headers from "./views/Headers.vue";
// import AcceptanceList from "./views/ReceivedO4rder/AcceptanceList.vue";
import AcceptDetails from "./views/ReceivedO4rder/AcceptDetails.vue";
import users from "./views/users.vue";
import { MessageBox } from "element-ui";
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

var router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/index",
      meta: {
        title: "“平行世界”数字孪生服务平台",
        content: {
          keywords:
            "泰瑞数创SmartEarth：全产业链数字孪生技术与服务专家，三维外业，倾斜摄影，三维数据，三维数据采集，航测，三维模型，实景三维，数字孪生，三维可视化，三维仿真，数字双胞胎，三维实景，航飞，航空测绘，航空摄影，建模，建模处理，模型轻量化，三维可视化，建模软件，SmartEarth数字孪生，实景三维，语义三维，智慧城市，倾斜摄影测量，三维GIS，三维数字地球，大数据可视化，车联网，物联网，数字孪生，数字孪生城市，数字孪生工业，数字孪生交通，数字孪生自动驾驶，数字孪生全产业链，航飞数据，倾斜摄影，三维倾斜，三维建模，语义建模，工业4.0，工业互联网，智能生产线，智慧城市，智慧园区，智慧水利，智慧公安，城市大脑，智慧工厂，智慧能源，三维高精地图",
          description:
            "泰瑞数创SmartEarth：全产业链数字孪生技术与服务专家，三维外业，倾斜摄影，三维数据，三维数据采集，航测，三维模型，实景三维，数字孪生，三维可视化，三维仿真，数字双胞胎，三维实景，航飞，航空测绘，航空摄影，建模，建模处理，模型轻量化，三维可视化，建模软件，SmartEarth数字孪生，实景三维，语义三维，智慧城市，倾斜摄影测量，三维GIS，三维数字地球，大数据可视化，车联网，物联网，数字孪生，数字孪生城市，数字孪生工业，数字孪生交通，数字孪生自动驾驶，数字孪生全产业链，航飞数据，倾斜摄影，三维倾斜，三维建模，语义建模，工业4.0，工业互联网，智能生产线，智慧城市，智慧园区，智慧水利，智慧公安，城市大脑，智慧工厂，智慧能源，三维高精地图"
        }
      }
    },

    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/apply",
      component: Apply
    },
    {
      path: "/registered",
      name: "Registered",
      component: Registered
    },
    {
      path: "/clause",
      component: Clause
    },

    {
      path: "/forget",
      component: Forget,
      redirect: "/verification",
      children: [
        { path: "/verification", component: Verification },
        { path: "/smsVerification", component: SmsVerification },
        { path: "/modify", component: Modify },
        { path: "/complete", component: Complete }
      ]
    },
    {
      path: "/users",
      name: "users",
      component: users,
      redirect: "/userTab",
      children: [
        {
          path: "/certification",
          name: "Certification",
          component: Certification
        },
        {
          path: "/enterCertifi",
          name: "enterCertifi",
          component: EnterCertifi
        },
        {
          path: "/dataProcessing",
          name: "DataProcessing",
          component: DataProcessing
        },
        {
          path: "/dataAcquisition",
          name: "DataAcquisition",
          component: DataAcquisition
        },
        {
          path: "/dataAcquisitionSecond",
          name: "DataAcquisitionSecond",
          component: DataAcquisitionSecond
        },
        {
          path: "/orderContent/:data",
          name: "orderContent",
          component: OrderContent
        },
        {
          path: "/acceptDetails",
          name: "AcceptDetails",
          component: AcceptDetails
        },
        {
          path: "/userTab",
          name: "UserTab",
          component: UserTab
        }
      ]
    },
    {
      path: "/headers",
      component: Headers,
      redirect: "/users",
      children: [
        {
          path: "/index",
          name: "Index",
          component: Index,
          meta: {
            title: "“平行世界”数字孪生服务平台",
            content: {
              keywords:
                "泰瑞数创SmartEarth：全产业链数字孪生技术与服务专家，倾斜摄影，三维数据，三维数据采集，航测，三维模型，实景三维，数字孪生，三维可视化，三维仿真，数字双胞胎，三维实景，航飞，航空测绘，航空摄影，建模，建模处理，模型轻量化，三维可视化，建模软件，SmartEarth数字孪生，实景三维，语义三维，智慧城市，倾斜摄影测量，三维GIS，三维数字地球，大数据可视化，车联网，物联网，数字孪生，数字孪生城市，数字孪生工业，数字孪生交通，数字孪生自动驾驶，数字孪生全产业链，航飞数据，倾斜摄影，三维倾斜，三维建模，语义建模，工业4.0，工业互联网，智能生产线，智慧城市，智慧园区，智慧水利，智慧公安，城市大脑，智慧工厂，智慧能源，三维高精地图",
              description:
                "泰瑞数创SmartEarth：全产业链数字孪生技术与服务专家，倾斜摄影，三维数据，三维数据采集，航测，三维模型，实景三维，数字孪生，三维可视化，三维仿真，数字双胞胎，三维实景，航飞，航空测绘，航空摄影，建模，建模处理，模型轻量化，三维可视化，建模软件，SmartEarth数字孪生，实景三维，语义三维，智慧城市，倾斜摄影测量，三维GIS，三维数字地球，大数据可视化，车联网，物联网，数字孪生，数字孪生城市，数字孪生工业，数字孪生交通，数字孪生自动驾驶，数字孪生全产业链，航飞数据，倾斜摄影，三维倾斜，三维建模，语义建模，工业4.0，工业互联网，智能生产线，智慧城市，智慧园区，智慧水利，智慧公安，城市大脑，智慧工厂，智慧能源，三维高精地图"
            }
          }
        },
        {
          path: "/softwareCenter",
          name: "SoftwareCenter",
          component: SoftwareCenter
        },
        {
          path: "/taiRuiCollege",
          name: "TaiRuiCollege",
          component: TaiRuiCollege
        },

        {
          path: "/dataCollection",
          name: "DataCollection",
          component: DataCollection
        },
        {
          path: "/dataProcessingOrder",
          name: "DataProcessingOrder",
          component: DataProcessingOrder
        },
        {
          path: "/acquisitionProcessing",
          name: "AcquisitionProcessing",
          component: AcquisitionProcessing
        },
        {
          path: "/solution",
          name: "Solution",
          component: Solution
        },
        {
          path: "/otherServices",
          name: "OtherServices",
          component: OtherServices
        }
      ]
    }
  ]
});

// 路由守卫设置
router.beforeEach(function(to, from, next) {
  var token = window.sessionStorage.getItem("userId");
  var type = window.sessionStorage.getItem("userType");
  if (token === null && to.path !== "/login") {
    if (
      to.path.includes("/apply") ||
      to.path.includes("/verification") ||
      to.path.includes("/smsVerification") ||
      to.path.includes("/modify") ||
      to.path.includes("/complete") ||
      to.path.includes("/clause") ||
      to.path.includes("/registered") ||
      to.path.includes("/index")
    ) {
      next();
    } else {
      // return next("/login");
      return MessageBox.confirm("当前未登录，请前往登录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          next("/login");
        })
        .catch(() => {});
    }
  }
  if (
    to.path == "/dataCollection" ||
    to.path == "/dataProcessingOrder" ||
    to.path == "/solution" ||
    to.path == "/acquisitionProcessing" ||
    to.path == "/dataAcquisition" ||
    to.path == "/dataAcquisitionSecond" ||
    to.path == "/dataProcessing"
  ) {
    if (type == "0") {
      return MessageBox.confirm(
        "当前登录状态为个人账号，注册企业账号后可进入页面",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          next("/registered");
        })
        .catch(() => {});
    }
    next();
  }
  next(); // 放行
});
export default router;
